<template>
  <div>
    <!-- 
			New modal dialog 
		-->
    <a-modal v-model="dialogVisible" :title="title" :maskClosable="false" forceRender @ok="onSubmit">
      <div style="margin: 10px 0">
        Name *
        <a-input v-model="name" placeholder="" />
      </div>
      <div style="margin-top: 10px;">
        Remark
        <a-textarea v-model="remark" placeholder="" :rows="10" />
      </div>
    </a-modal>
    <!-- 
			Group's detail 
		-->
    <a-modal v-model="dialogVisibleGroupMember" :title="titleGroupMember" width="800px" forceRender>
      <template slot="footer">
        <a-button key="ok" type="primary" @click="onCloseGroupMember">
          OK
        </a-button>
      </template>
      <!-- Data -->
      <div style="overflow-y: scroll; height: 600px;">
        <a-table :columns="columnsMember" :data-source="dataMember" :pagination="false" rowKey="_id">
          <template slot="action" slot-scope="row">
            <div style="float: right">
              <a-button type="danger" shape="circle" icon="delete" @click="onDeleteMember(row)" />
            </div>
          </template>
        </a-table>
      </div>
    </a-modal>

    <!-- 
			Search modal dialog 
		-->
    <simpleSearch ref="simpleSearch" placeholder="ข้อความ" :search="onSearchSubmit" />
    <searchUser ref="searchUser" :selected="onNewMemberSubmit" />

    <!-- 
			Data, desktop's view
		-->
    <div>
      <a-card :bordered="false" class="header-solid h-full">
        <!-- Title -->
        <template #title>
          <a-row type="flex" justify="space-between" align="top">
            <a-col :span="12">
              <h5 class="font-semibold m-0">Group Attendee</h5>
            </a-col>
            <a-col :span="12" style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
              ">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Download excel file</span>
                </template>
                <a-button type="default" shape="circle" icon="file-excel" @click="onClickDownloadExcel" />
              </a-tooltip>
              <a-divider type="vertical" />
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Clear</span>
                </template>
                <a-button type="default" shape="circle" icon="reload" @click="onClear" /> </a-tooltip>&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>Search</span>
                </template>
                <a-button type="default" shape="circle" icon="search" @click="onSearch" /> </a-tooltip>&nbsp;
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>New</span>
                </template>
                <a-button type="primary" shape="circle" icon="plus" @click="onNew" /></a-tooltip>
            </a-col>
          </a-row>
        </template>
        <!-- Body -->
        <a-table :columns="columns" :data-source="data" rowKey="_id">
          <template slot="status" slot-scope="status">
            <a-tag v-if="status === 'Enable'" color="green">{{ status }}</a-tag>
            <a-tag v-if="status === 'Disable'" color="red">{{ status }}</a-tag>
          </template>
          <template slot="remark" slot-scope="remark">
            <span style="white-space: pre-line">{{ remark }}</span>
          </template>
          <template slot="action" slot-scope="row">
            <div style="float: right">
              <a-dropdown-button>
                Options
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="onShowMember(row)">
                    <a-icon type="info" /> Show Members</a-menu-item>
                  <a-menu-item key="2" @click="onShowNewMember(row)">
                    <a-icon type="plus" /> New Members</a-menu-item>
                  <a-menu-item key="3" @click="onEdit(row)">
                    <a-icon type="edit" /> Edit</a-menu-item>
                  <a-menu-item key="4" @click="onDelete(row)">
                    <a-icon type="delete" />
                    <span style="color: #ff0000">Delete</span></a-menu-item>
                </a-menu>
              </a-dropdown-button>
            </div>
          </template>
        </a-table>
      </a-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import simpleSearch from "../../components/Search/SimpleSearch";
import searchUser from "../../components/Search/SearchUser";
import tools from "../../utils/tools";
import notify from "../../utils/notify";

export default {
  //
  //
  //
  components: {
    simpleSearch,
    searchUser,
  },
  //
  //
  //
  data() {
    return {
      data: [],
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Remark",
          dataIndex: "remark",
          scopedSlots: { customRender: "remark" }
        },
        {
          title: "",
          dataIndex: "",
          scopedSlots: { customRender: "action" }
        }
      ],
      //
      dataMember: [],
      columnsMember: [
        {
          title: "Username",
          dataIndex: "userEmail",
          scopedSlots: { customRender: "userEmail" }
        },
        {
          title: "Name",
          dataIndex: "userName",
          scopedSlots: { customRender: "userName" }
        },
        {
          title: "",
          dataIndex: "",
          scopedSlots: { customRender: "action" }
        }
      ],
      //
      mode: "new",
      // New group
      dialogVisible: false,
      title: "New",
      // Group member
      dialogVisibleGroupMember: false,
      titleGroupMember: "",
      // Data
      id: "",
      name: "",
      remark: "",
    };
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },
  //
  //
  //
  created() { },
  //
  //
  //
  beforeMounted() { },
  //
  //
  //
  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      return;
    }
    this.requestData();
  },
  //
  //
  //
  beforeUpdated() { },
  //
  //
  //
  updated() { },
  //
  //
  //
  beforeDestroy() { },
  //
  //
  //
  destroyed() { },
  //
  //
  //
  methods: {
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    // Request data.
    //
    requestData() {
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/group-attendees", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    //
    //
    async onShowMember(item) {
      this.dialogVisibleGroupMember = true;
      this.titleGroupMember = item.name + "'s member";
      // Get group's member
      const response = await axios.get(
        process.env.VUE_APP_INVENTORY_API + "/group-attendees/members/" + item._id,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        }
      );
      this.dataMember = response.data.data;
    },
    //
    //
    //
    onShowNewMember(group) {
      this.selectedGroup = group;
      this.$refs.searchUser.show();
    },
    //
    //
    //
    onNewMemberSubmit(data, isGroup) {
      console.debug("data = ", data)

      // Add new member
      axios
        .post(
          process.env.VUE_APP_INVENTORY_API + "/group-attendees/member",
          {
            groupId: this.selectedGroup._id,
            groupName: this.selectedGroup.name,
            userId: data._id,
            userEmail: data.email,
            userName: data.name,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          if (response.data.success) {
            this.selectedUserEmail = "";
            notify.successNotify(
              this.$notification,
              <a-icon type="check-circle" style="color: #00FF00" />,
              "บันทึกข้อมูลเรียบร้อย"
            );
          } else {
            notify.errorNotify(
              this.$notification,
              <a-icon type="close-circle" style="color: #FF0000" />,
              response.data.message
            );
          }
          return;
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    //
    //
    onCloseGroupMember() {
      this.dialogVisibleGroupMember = false;
    },
    //
    // New data.
    //
    onNew() {
      this.dialogVisible = true;
      this.mode = "new";
      this.title = "New";
      //
      this.id = "";
      this.name = "";
      this.remark = "";
    },
    //
    // Edit data.
    //
    onEdit(item) {
      this.dialogVisible = true;
      this.mode = "edit";
      this.title = "Edit";
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/group-attendees/get/" + item._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          const data = response.data.data;

          this.id = data._id;
          this.name = data.name;
          this.remark = data.remark;
        })
        .catch(error => {
          notify.successNotify(
            this.$notification,
            <a-icon type="check-circle" style="color: #00FF00" />,
            "บันทึกข้อมูลเรียบร้อย"
          );
          return;
        });
    },
    //
    //
    //
    onSubmit() {
      this.dialogVisible = false;

      // Check require fields
      if (this.name === "") {
        notify.errorNotify(
          this.$notification,
          <a-icon type="close-circle" style="color: #FF0000" />,
          "ใส่ข้อมูลไม่ครบ"
        );
        return;
      }

      //
      if (this.mode === "new") {
        let payload = {
          name: this.name,
          remark: this.remark,
        };

        console.log("payload = ", payload);

        axios
          .post(
            process.env.VUE_APP_INVENTORY_API + "/group-attendees",
            payload,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("accessToken")
              }
            }
          )
          .then(response => {
            notify.successNotify(
              this.$notification,
              <a-icon type="check-circle" style="color: #00FF00" />,
              "บันทึกข้อมูลเรียบร้อย"
            );
            this.requestData();
          })
          .catch(error => {
            notify.errorNotify(
              this.$notification,
              <a-icon type="close-circle" style="color: #FF0000" />,
              error
            );
            return;
          });
      } else {
        let payload = {
          name: this.name,
          remark: this.remark,
        };

        console.log("payload = ", payload);

        axios
          .put(
            process.env.VUE_APP_INVENTORY_API + "/group-attendees/" + this.id,
            payload,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("accessToken")
              }
            }
          )
          .then(response => {
            notify.successNotify(
              this.$notification,
              <a-icon type="check-circle" style="color: #00FF00" />,
              "บันทึกข้อมูลเรียบร้อย"
            );
            this.requestData();
          })
          .catch(error => {
            notify.errorNotify(
              this.$notification,
              <a-icon type="close-circle" style="color: #FF0000" />,
              error
            );
            return;
          });
      }
    },
    //
    // Delete data.
    //
    onDelete(item) {
      const self = this;
      this.$confirm({
        title: "ต้องการลบข้อมูลนี้หรือไม่?",
        onOk() {
          self.delete(item);
        },
        onCancel() { }
      });
    },
    //
    // Delete data.
    //
    delete(item) {
      axios
        .delete(process.env.VUE_APP_INVENTORY_API + "/group-attendees/" + item._id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          notify.successNotify(
            this.$notification,
            <a-icon type="check-circle" style="color: #00FF00" />,
            "ลบข้อมูลเรียบร้อย"
          );
          this.requestData();
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    // Delete data.
    //
    async onDeleteMember(groupMember) {
      axios
        .delete(
          process.env.VUE_APP_INVENTORY_API +
          "/group-attendees/member/" +
          groupMember._id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken")
            }
          }
        )
        .then(response => {
          notify.successNotify(
            this.$notification,
            <a-icon type="check-circle" style="color: #00FF00" />,
            "ลบข้อมูลเรียบร้อย"
          );

          // Get group's member
          axios
            .get(
              process.env.VUE_APP_INVENTORY_API +
              "/group-attendees/members/" +
              groupMember.groupId,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("accessToken")
                }
              }
            )
            .then(response => {
              this.dataMember = response.data.data;
            })
            .catch(error => {
              notify.errorNotify(
                this.$notification,
                <a-icon type="close-circle" style="color: #FF0000" />,
                error
              );
              return;
            });
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    //
    //
    onClear() {
      this.$refs.simpleSearch.clearFilter();
      this.requestData();
    },
    //
    // Search data.
    //
    async onSearch() {
      this.$refs.simpleSearch.show();
    },
    //
    //
    //
    async onSearchSubmit(text) {
      axios
        .get(process.env.VUE_APP_INVENTORY_API + "/group-attendees/search?q=" + text, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        })
        .then(response => {
          this.data = response.data.data;
        })
        .catch(error => {
          notify.errorNotify(
            this.$notification,
            <a-icon type="close-circle" style="color: #FF0000" />,
            error
          );
          return;
        });
    },
    //
    //
    //
    onClickDownloadExcel() {
      let csv = "Name,Remark\n";
      this.data.forEach(row => {
        csv += row.name + ",";
        csv += row.remark;
        csv += "\n";
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "group-attendees.csv";
      anchor.click();
    },
  }
};
</script>

<style lang="scss">
table>tbody>tr {
  vertical-align: top;
}
</style>
